import { Injectable } from '@angular/core';
import { NavigationEnd, Route, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CurrentRouteConfigService {
  private currentRouteConfigSubject = new BehaviorSubject<Route | null>(null);

  constructor(private router: Router) {
    this.updateCurrentRouteConfig();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateCurrentRouteConfig();
      }
    });
  }

  private updateCurrentRouteConfig(): void {
    let currentRoute = this.router.routerState.root;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }
    this.currentRouteConfigSubject.next(currentRoute.routeConfig);
  }

  get(): Route | null {
    return this.currentRouteConfigSubject.value;
  }

  get currentRouteConfig$(): Observable<Route | null> {
    return this.currentRouteConfigSubject.asObservable();
  }
}
